export type LatLng = { lat: number; lng: number; };

export enum MaintenanceKind {
  planned, preemptive, issue
};

export type MaintenanceMarker = {
  name: string;
  park: number,
  agency_id: number,
  date: string;
  address: string,
  agency: string;
  cabinet_key: boolean,
  cabinet_position: string,
  contract_type: string,
  location: LatLng;
  readonly kind: MaintenanceKind;
};

export type PreemptiveMaintenanceMarker = MaintenanceMarker & {
  how_approach_client: string;
  number_of_cs: number;
  last_preventive_date: string;
  readonly kind: MaintenanceKind.preemptive;
};

export type IssueMarker = MaintenanceMarker & {
  issue_id: number;
  issue_title: string;
  issue_how_to_solve: string;
  made_by: number,
  priority: number,
  readonly kind: MaintenanceKind.issue
};

export function is_preemptive(m: MaintenanceMarker): m is PreemptiveMaintenanceMarker {
  // const x = (m as PreemptiveMaintenanceMarker);
  // return x.address !== undefined;
  return m.kind === MaintenanceKind.preemptive;
}

export function is_issue(m: PreemptiveMaintenanceMarker | IssueMarker): m is IssueMarker {
  // const x = (m as IssueMarker);
  // return x.issue_id !== undefined && x.issue_title !== undefined;
  return m.kind === MaintenanceKind.issue;
}
